module.exports = __webpack_public_path__ + "img/shouye_bg_banner.min.6463c355.png";